import { methods } from "../../utils/axios";

const TEST_REQUEST_CONFIG = { timeout: 20000, proxyFallback: true };

export default class CollaboratorsAPI {
  static downloadReports(params) {
    return methods.post('/collaborators/download-reports', params);
  }
  static sendReports(params) {
    return methods.post('/clients/notify-reports-email', params);
  }
  static collaboratorsList(params) {
    return methods.post('/collaborators/paginate', params);
  }
  static collaboratorTests(params) {
    return methods.post('/collaborators/with_tests', params);
  }
  static updateCollaborator(data, id) {
    return methods.put(`/collaborators/${id}`, data);
  }
  static createCollaborator(data) {
    return methods.post('/collaborators', data);
  }
  static resendInvitation(data) {
    return methods.post('/collaborator_tests/send', data);
  }
  // Invitación o recordatorio desde la casilla de quien está en el panel (Gmail).
  static sendFromMailbox(data) {
    return methods.post('/collaborator_tests/send-from-mailbox', data, { timeout: 30000 });
  }
  static sendInvitation(data) {
    return methods.put('/collaborator_tests', data);
  }
  static buildIaSummary(data) {
    return methods.post('/prompt', data);
  }
  static bulkLoad(data) {
    // return axiosMethods.postDocument('/collaborators/bulk-load', data);
    const headers = { 'Content-Type': 'multipart/form-data' };

    return methods.post('/collaborators/bulk-load', data, { headers });
  }
  static donwloadInform(id, extension) {
    // return axiosMethods.get(`/${id}.${extension}`);
    return methods.get(`/${id}.${extension}`);
  }
  static getExcelTemplate() {
    // return axiosMethods.get('/collaborators/excel')
    return methods.get('/collaborators/excel')
  }
  static deleteCollaborator(id) {
    return methods.del('/collaborators', id)
  }
  // Pedidos de la página pública del test: con timeout (una red que los deja colgados
  // no debe trabar el test) y reintento por el proxy del front si el back no responde.
  static discColorPair(answers) {
    return methods.post('/collaborator_tests/disc_color_pair', { answers }, TEST_REQUEST_CONFIG);
  }
  static startTestSession(collaboratorTestID, progress) {
    return methods.post('/collaborator_tests/session/start', { collaboratorTestID, progress }, TEST_REQUEST_CONFIG);
  }
  static saveTestProgress(collaboratorTestID, progress) {
    return methods.post('/collaborator_tests/session/progress', { collaboratorTestID, progress }, TEST_REQUEST_CONFIG);
  }
  // El envío calcula los resultados en el mismo pedido: necesita más margen.
  static postTestAnswers(body) {
    return methods.post('/collaborator_tests/post_answers', body, { timeout: 90000, proxyFallback: true });
  }
}